// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.scroll-tbl{height:495px; overflow-y:auto;}\n/* width */\n.scroll-tbl::-webkit-scrollbar {width: 5px;}\n/* Track */\n.scroll-tbl::-webkit-scrollbar-track {background: transparent;}\n/* Handle */\n.scroll-tbl::-webkit-scrollbar-thumb {background: #818181; border-radius:5px;}\n/* Handle on hover */\n.scroll-tbl::-webkit-scrollbar-thumb:hover {background: #555;}\n", ""]);
// Exports
module.exports = exports;
